import { render, staticRenderFns } from "./AssignmentSidebar.vue?vue&type=template&id=b74c9ac8"
import script from "./AssignmentSidebar.vue?vue&type=script&lang=js"
export * from "./AssignmentSidebar.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSidebar.vue?vue&type=style&index=0&id=b74c9ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports